import moment from "moment";
import { amountFormat } from "../services/common.service";
import { ReactComponent as DownloadIcon } from "../assests/icons/download.svg";
import { Button, Empty } from "antd";
import { useTranslation } from "react-i18next";

export default function GepgHistoryList({
  dataSource = [],
  handleDownload,
  setDetails,
  setVisible,
  hasMoreRecords,
  fetchMoreHistory,
}) {
  const { t } = useTranslation();

  return (
    <>
      {dataSource.length === 0 ? (
        <Empty
          description={t("pages.transfer_limit.no_record_found", {
            defaultValue: "No Record found",
          })}
        />
      ) : (
        <div>
          <div style={{ cursor: "pointer" }}>
            {dataSource.map((option, idx) => (
              <div
                key={idx}
                onClick={() => {
                  setDetails(option);
                  setVisible(true);
                }}
              >
                <div className="account-row-data mb-2">
                  <div className="list-row-display-item ">
                    <div>
                      <div className="list-item-heading">
                        <span
                          className="pay-now-text"
                          style={{
                            textDecoration: "underline",
                            whiteSpace: "break-spaces",
                            wordBreak: "break-all",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleDownload(option);
                          }}
                        >
                          <span className="refspan">
                            {option.debitAccount || "-"}
                          </span>
                        </span>
                      </div>
                      <div className="list-item-heading">
                        {option.controlNum || "-"}
                      </div>
                      <div className="list-item-heading">
                        {option.billCcy || "-"}
                      </div>
                    </div>
                    <div align="right">
                      <div className="list-item-heading">
                        {option?.initDate && (
                          <span>
                            {moment(option?.initDate).format("DD-MM-YYYY") ||
                              "-"}
                          </span>
                        )}
                      </div>
                      <div className="list-item-heading">
                        {amountFormat(option.paidAmount, option?.debitCcy)}
                      </div>
                      <div className="list-item-heading">
                        {option?.status === "SUCCESS" ? (
                          <span className="success-text px-2 py-1">
                            {t("common.success_cap", {
                              defaultValue: "SUCCESS",
                            })}
                          </span>
                        ) : option?.status == null ? (
                          <span className="px-2 py-1">-</span>
                        ) : (
                          <span className="fail-error px-2 py-1">
                            {option?.status || "-"}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {hasMoreRecords && (
        <div align="center" className="mt-3">
          <Button type="default" onClick={() => fetchMoreHistory()}>
            {t("buttons.load_more_records_btn", {
              defaultValue: "Load More Records",
            })}
          </Button>
        </div>
      )}
    </>
  );
}
